import {
	contractSuretyAccountUnderwritingModelSizeSchema,
	currencySchema,
	isoDateSchema,
	suretyAccountUnderwritingId,
	suretyAccountUnderwritingStatusSchema,
	suretyTypeSchema,
} from "@inrev/common";
import * as z from "zod";
import { reviewReasonSchema } from "../schemas/review-reasons";
import { defineTool } from "../tool-definition";

export const getUnderwriting = defineTool({
	name: "get_underwriting",
	description:
		"The account's latest contract underwriting run only: earlier runs' scores, review reasons, limits and approvals are not in this result. `recommendedSingleLimit` and `recommendedAggregateLimit` are the scoring model's output, not the bonding line; read capacity from `get_account`. A run still `processing` has no score of its own, so `score` then comes from the newest finished run and `scoreIsFromPreviousRun` is true. `modelSize` sets which financial statements the account needs, the metrics it is scored on, and the level each review reason fires at. `stale` means an input changed since the run and it needs re-running. `reviewReasons` include inactive ones, which the admin overview still lists after approval; Missing-property reasons with the same `active` come as one entry: `properties` names every missing property and `description` joins theirs. `properties` is empty for every other reason. Null when the account has never been underwritten.",
	label: "Underwriting",
	contexts: ["account", "bond_request", "bond"],
	implementation: "api",
	audience: "model",
	input: z.strictObject({}),
	data: z
		.strictObject({
			underwritingId: suretyAccountUnderwritingId,
			suretyType: suretyTypeSchema,
			status: suretyAccountUnderwritingStatusSchema,
			modelSize: contractSuretyAccountUnderwritingModelSizeSchema,
			recommendedSingleLimit: currencySchema.nullable(),
			recommendedAggregateLimit: currencySchema.nullable(),
			expiresAt: isoDateSchema,
			reviewedAt: isoDateSchema.nullable(),
			stale: z.boolean(),
			score: z.number().nullable(),
			scoreIsFromPreviousRun: z.boolean(),
			reviewReasons: z.array(reviewReasonSchema),
		})
		.nullable(),
});
